var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nuttrema-dot-kcal",class:[_vm.className.kcal],attrs:{"title":_vm.title}},[_c('el-tooltip',{attrs:{"content":_vm.$t(_vm.label, { kcal: _vm.enercKcal, grams: _vm.grams }),"placement":"right","effect":"dark"}},[_c('span',{staticClass:"dot"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-698589ae","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/label/nuttrema-dot-kcal.vue
// module id = 3158
// module chunks = 0